import { useMemo, useState } from 'react';
import { downloadFileFromBlob } from '@dealstack/frontend/shared/files/downloadFile.ts';
import { getValidFileNameForDownload } from '@dealstack/shared/lib/common/file/file.ts';
import { FileExtension } from '@dealstack/shared/lib/common/dataExchange/common.ts';

export const useImageViewerController = ({
	showDetailsByDefault,
	file,
	fileName,
	fileExtension,
}: {
	showDetailsByDefault: boolean;
	fileName: string;
	file?: Blob | string;
	fileExtension: FileExtension;
}) => {
	const [imageSizePercent, setImageSizePercent] = useState(100);
	const [showDetails, setShowDetails] = useState(showDetailsByDefault);

	const imageSrcUrl = useMemo(() => {
		if (!file) {
			return;
		}

		if (typeof file === 'string') {
			return file;
		}

		return URL.createObjectURL(file);
	}, [file]);

	const onDownload = () => {
		if (!file) {
			return;
		}

		if (typeof file === 'string') {
			window.open(file, '_blank');
			return;
		}

		const fileNameToDownload = getValidFileNameForDownload(fileName, fileExtension);
		downloadFileFromBlob(file, fileNameToDownload);
	};

	const onScaleChange = (increase: boolean) => {
		setImageSizePercent((prevState) => (increase ? prevState + 20 : prevState - 20));
	};

	return {
		onScaleChange,
		onDownload,
		setShowDetails,
		showDetails,
		imageSizePercent,
		imageSrcUrl,
	};
};
